export function isMac(): boolean {
    return navigator.platform.startsWith('Mac');
}

/**
 * Format a keybinding string ("Ctrl+Shift+Z", "Enter", "Ctrl+↑ / Ctrl+↓") for
 * display. On Mac, each " / "-separated alternative gets Ctrl→⌘, Shift→⇧,
 * Alt→⌥ with the "+" separators removed; elsewhere it is returned as-is.
 */
export function formatKeybinding(binding: string): string {
    if (!isMac()) return binding;

    return binding
        .split(' / ')
        .map(chord =>
            chord
                .split('+')
                .map(part => {
                    switch (part) {
                        case 'Ctrl':
                            return '⌘';
                        case 'Shift':
                            return '⇧';
                        case 'Alt':
                            return '⌥';
                        default:
                            return part;
                    }
                })
                .join(''),
        )
        .join(' / ');
}
